import React from 'react';
import { FadeIn } from './FadeIn';
export function Headline() {
  return <section className="bg-white py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-60">
      <div className="max-w-4xl mx-auto text-center" data-id="element-61">
        <FadeIn data-id="element-62">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-black leading-tight mb-6" data-id="element-63">
            What If Your Joint Pain Isn't Wear and Tear... But a Silent Fire You
            Can Put Out From Your Kitchen?
          </h1>
          <p className="text-lg md:text-xl text-gray-600 font-sans max-w-3xl mx-auto leading-relaxed" data-id="element-64">
            Discover the 7-day protocol that women over 55 are using to recover
            their mobility without pills, injections, or expensive supplements
          </p>
        </FadeIn>
      </div>
    </section>;
}